import React, { useState, useEffect } from "react";
import {
  Accordion
} from "react-bootstrap";
import { CategoryControl, SearchControl } from "../components";
import { Modal_Loading } from "../modal";
import { db, firebaseAuth } from "../db/firestore";
import { compareArrays, searchFilterFunction, totalField } from "../Utility/function";


const anynonymous  = [
    "owner@gmail.com", "owner2@gmail.com", "owner3@gmail.com", 
    "owner4@gmail.com", "owner5@gmail.com", "owner6@gmail.com", 
    "owner7@gmail.com", "owner8@gmail.com", "owner9@gmail.com", 
    "owner10@gmail.com", 
  ];

function SelfServiceScreen() {

    const [current, setCurrent] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [currentCategory, setCurrentCategory] = useState([]);
    const [categorySetting, setCategorySetting] = useState([]);
    const [currentDisplay, setCurrentDisplay] = useState([]);

    useEffect(()=>{
        handleFetch()
    },[]);
    
    async function handleFetch(){
        setLoading(true);
        try {
            await firebaseAuth.signInWithEmailAndPassword(anynonymous[Math.floor(Math.random() * anynonymous.length)], '123456');
            const questionDoc = await db.collection('admin').doc('question').get();
            const { value, category } = questionDoc.data();
            setCurrent(value)
            setCurrentCategory(category)
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }


    useEffect(()=>{
        let length = categorySetting.length;
        let result = []
        for(const item of current){
            if(length >=1){
                if(compareArrays(item.category.slice(0,length),totalField(categorySetting,'id'))){
                    result.push(item)
                }
            } else {
                result.push(item)
            }
        }
        if(search){
        result = searchFilterFunction(result,search,'q')
        }

        setCurrentDisplay(result)
    },[current,categorySetting,search]);

  return (
    <div style={{ padding:10 }} >
        <Modal_Loading show={loading} />
        <h1>คำถามที่พบบ่อย</h1>
        <SearchControl {...{ placeholder:'ค้นหาด้วยชื่อ', search, setSearch }} />
        <CategoryControl {...{ warehouseCategory:currentCategory, categorySetting, setCategorySetting }} />
        <h5>ทั้งหมด {currentDisplay.length}/{current.length} คำตอบ</h5>
        <br/>
        <Accordion>
            {current.map((item,index)=>{
                return <Accordion.Item eventKey={index}>
                            <Accordion.Header>{index+1}. {item.q}</Accordion.Header>
                            <Accordion.Body>
                            {item.a.split('\n').map((line, index) => (
                            <React.Fragment key={index}>
                                &emsp;&nbsp;{line}
                                <br />
                            </React.Fragment>
                            ))}
                            </Accordion.Body>
                        </Accordion.Item>
            })}
        </Accordion>
    </div>
  );
}

export default SelfServiceScreen;